import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../../helpers/genericFormator';

export default function TxnPeriodFormatter(props) {
  const { row, data } = props;
  return (
    <div>
      {formatDate(data, 'DD MMM, YYYY ')} -{' '}
      {formatDate(row.to_date, 'DD MMM, YYYY ')}
    </div>
  );
}
TxnPeriodFormatter.propTypes = {
  type: PropTypes.string,
  row: PropTypes.object,
};
TxnPeriodFormatter.defaultProps = {
  type: '',
  row: {},
};
